import { BoxProps, ColorOptions } from '@jfs/ui-new'

const styles = {
  underline: (tintColorProp: ColorOptions) =>
    ({
      borderColor: tintColorProp,
      borderBottomWidth: 1,
      paddingBottom: 'TINY',
      direction: 'row',
      align: 'center',
      height: '25px',
    } as BoxProps),
}

export { styles }
